import { Button } from '@equitymultiple/react-eui';
import { GatsbyImage } from 'gatsby-plugin-image';
import React, { useEffect, useState } from 'react';

import { Routes } from '../../../../constants';
import { getCookie } from '../../../../utils/cookies';
import SvgProjector from '../../../SvgProjector/SvgProjector';
import {
  ExpandedKegDataProps,
  InvestmentType,
} from '../../expandedKegResources';
import * as styles from './MobileExpandedKeg.module.scss';

const MobileExpandedKeg: React.FC<
  Omit<ExpandedKegDataProps, 'description' | 'listItems'>
> = ({
  investmentType,
  kegIconPath,
  subHeader,
  mobileDescription,
  mainImageDescription,
  mainImage,
}) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const userCookie = getCookie('user');

    if (userCookie) {
      setIsActive(true);
    }
  }, []);

  return (
    <div className={styles.mobileSingleExpandedKeg}>
      <div className={styles.content}>
        <div className={styles.iconHeaderContainer}>
          <h2 className="heading2 expressive">
            {' '}
            {investmentType.charAt(0).toUpperCase() + investmentType.slice(1)}
          </h2>
          <SvgProjector fileUrl={kegIconPath} />
        </div>
        <h6 className={`${styles.subHeader} heading6`}>{subHeader}</h6>
        <span className={`${styles.mobileDescription} subHeading`}>
          {mobileDescription}
        </span>
        <div>
          <span className={`${styles.imageHeader} overline`}>
            Representative Investment
          </span>
          <a
            href={mainImageDescription.offeringLink}
            className={styles.mainImageDescriptionLink}
          >
            <div className={styles.mainImageContainer}>
              <GatsbyImage
                alt={mainImage.altText}
                image={mainImage.gatsbyImage}
                className={styles.gatsbyImage}
              />
            </div>
            <span className={`${styles.imageDescriptionHeader} body1 emphasis`}>
              {mainImageDescription.offeringName}
            </span>
          </a>
          <div className={styles.imageDescription}>
            <span className="disclaimer">
              {mainImageDescription.metric1.label}
            </span>
            <span>{mainImageDescription.metric1.value}</span>
          </div>
          <div className={styles.imageDescription}>
            <span className="disclaimer">
              {mainImageDescription.metric2.label}
            </span>
            <span>{mainImageDescription.metric2.value}</span>
          </div>
          <div className={styles.imageDescription}>
            <span className="disclaimer">
              {mainImageDescription.metric3.label}
            </span>
            <span>{mainImageDescription.metric3.value}</span>
          </div>
        </div>
        <Button
          href={isActive ? Routes.appOfferingsPage.url : Routes.signUp.url}
          className={styles.button}
          variant="outlined"
        >
          Unlock Live Investments
        </Button>
      </div>
      <div className={styles.tabContainer}>
        <div
          className={`${styles.tab} ${
            styles[investmentType as InvestmentType]
          }`}
        />
      </div>
    </div>
  );
};

export default MobileExpandedKeg;
